
const messageTemplate = document.createElement( 'div' );
messageTemplate.className = 'o-field__message';

const groupMessageTemplate = document.createElement( 'div' );
groupMessageTemplate.className = 'o-field__group-message';

class FormValidator {

	constructor( formEl ) {
		this.formEl = formEl;

		const inputEls = Array.from( this.formEl.elements );

		// Handle invalid inputEls.
		inputEls.forEach( ( inputEl ) => {
			inputEl.addEventListener( 'invalid', ( evt ) => {
				evt.preventDefault();
				this.onInvalid( inputEl, 'is-error', evt.detail?.message ?? '' );
			} );

			inputEl.addEventListener( 'warning', ( evt ) => {
				evt.preventDefault();
				this.onInvalid( inputEl, 'is-warning', evt.detail?.message ?? '' );
			} );
		} );

		const eventList = ['change', 'input', 'focusout', 'validate_input.acl', 'validated.acl'];
		eventList.forEach( eventName => {
			this.formEl.addEventListener( eventName, ( evt ) => {

				// Delegate to inputs.
				if ( evt.target.matches( '[data-validate]' ) ) {
					this.onChange( evt.target );
				}
			} );
		} );
	}

	onInvalid( inputEl, errorClass = 'is-error', message = '' ) {

		// Do not show Error Message, if not needed yet.
		if ( ! inputEl.matches( ':user-invalid' ) && ! inputEl.dataset.displayValidation ) {
			return;
		}

		const groupEl = inputEl.closest( '.o-field__group' );
		if ( groupEl ) {
			groupEl.classList.remove( 'is-success', 'is-warning', 'is-error' );
			if ( errorClass ) {
				groupEl.classList.add( errorClass );
			}
		} else {
			const wrapperEl = inputEl.closest( '.o-field' );
			if ( wrapperEl ) {
				wrapperEl.classList.remove( 'is-success', 'is-warning', 'is-error' );
				if ( errorClass ) {
					wrapperEl.classList.add( errorClass );
				}
			}
		}

		this.setMessage( inputEl, message );
	}

	setMessage( inputEl, message = '' ) {

		const groupEl = inputEl.closest( '.o-field__group' );
		if ( groupEl ) {
			const messageEl = groupEl.querySelector( '.o-field__group-message' ) || groupEl.appendChild( groupMessageTemplate.cloneNode( true ) );
			messageEl.defaultErrorMessage ??= messageEl.innerText;
			messageEl.innerHTML = message || inputEl.validationMessage || messageEl.defaultErrorMessage;
		} else {
			const wrapperEl = inputEl.closest( '.o-field' );
			if ( wrapperEl ) {
				const messageEl = wrapperEl.querySelector( '.o-field__message' ) || wrapperEl.appendChild( messageTemplate.cloneNode( true ) );
				messageEl.defaultErrorMessage ??= messageEl.innerText;
				messageEl.innerHTML = message || inputEl.validationMessage || messageEl.defaultErrorMessage;
			}
		}
	}


	onChange( inputEl ) {
		if ( inputEl.checkValidity() ) {
			this.onInvalid( inputEl, '' );
		}
	}
}

const initFormValidation = ( scopeEl = document ) => {
	const formEls = scopeEl.querySelectorAll( '.c_form' );
	formEls.forEach( ( formEl ) => {
		formEl.SL_FORM_VALIDATOR ??= new FormValidator( formEl );
	} );
}


export {
	FormValidator as default,
	initFormValidation
}
